exports = module.exports = require("../node_modules/.0.21.0@css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".secret[_v-d1361234] {\n  position: absolute;\n  clip: rect(0 0 0 0);\n  overflow: hidden;\n  margin: -1px;\n  height: 1px;\n  width: 1px;\n  padding: 0;\n  border: 0;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/.0.21.0@css-loader!./~/.7.1.7@vue-loader/lib/style-rewriter.js?id=_v-d1361234&file=Dropdown.vue&scoped=true!./~/.7.1.7@vue-loader/lib/selector.js?type=style&index=0!./src/Dropdown.vue
// module id = 129
// module chunks = 0


// WEBPACK FOOTER //
// webpack:///src/Dropdown.vue?cb0c